<template src="./MensajesUnificado.html"></template>

<script>
import { leerLista } from "../../../apiService/request/CrudTerapias";
import WhatsAppMessage from "./WhatsAppMessage/WhatsAppMessage";
import TextMessage from "./TextMessage/TextMessage";
import PushMessage from "./PushMessage/PushMessage";
import {
  phoneState,
  sendNotification,
} from "../../../apiService/request/crudMendajes";
import { localeData } from "moment";

export default {
  data() {
    return {
      messageType: [],
      messageTypeItems: [],
      seeWhatsAppMessages: false,
      patientOnline: false,
      colorOnline: "",
      dataMessage: {},
      documento: null,
      telefonoCelular: null,
      channels: [],
      traslate: {
        whatsapp: "whatsapp",
        mensajedetexto: "sms",
        notificaciónpush: "push",
      },
      seeSms: false,
      seeNotificationpush: false,
      seePush: false,
    };
  },
  async created() {
    await this.searchList();
    await this.statePhone();
  },
  methods: {
    lowerCaseSelected() {
      let nuevoarr = [];
      this.channels = [];
      this.messageType
        .map((e, i) => {
          this.channels[i] = this.traslate[e.toLowerCase().replace(/\s+/g, "")];
        })
        .push(this.traslate[nuevoarr]);
    },
    async sendInfoMessage(event) {
      this.infoPatient.forEach((e) => {
        if (e.key === "numero_documento") {
          this.documento = e.valor;
        }
        if (e.key === "telefono_celular") {
          this.telefonoCelular = e.valor.toString();
        }
      });
      this.dataMessage = event;
      this.dataMessage["phone"] = this.telefonoCelular;
      this.dataMessage["creado_por"] = this.$store.state.provider_email;
      let response = null;
      try {
        response = await sendNotification(
          this.documento,
          this.dataMessage,
          this.channels
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.messageType = [];
        this.seeWhatsAppMessages = false;
        this.seeSms = false;
        this.seePush = false;
        alert(response.data.message);
        this.$store.dispatch("setCargando", false);
      }
    },
    async statePhone() {
      this.$store.dispatch("setCargando", true);
      try {
        let phone = this.infoPatient.find((e) => e.key === "telefono_celular");
        let document = this.infoPatient.find(
          (e) => e.key === "numero_documento"
        );
        this.documento = document.valor;
        const response = await phoneState(`57${phone.valor}`);
        this.patientOnline = response.data.data.state;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    cancel() {
      this.seeWhatsAppMessages = false;
      this.seeSms = false;
      this.messageType = [];
    },
    async searchList() {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await leerLista("opciones_mensajes");
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.messageTypeItems = respuesta.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    checkType() {
      this.seeSms = false;
      this.seePush = false;
      this.seeWhatsAppMessages = false;
      this.seeNotificationpush = false;
      if (this.messageType.includes("WhatsApp")) {
        if (this.messageType.includes("Notificación push")) {
          this.seeNotificationpush = true;
        }
        this.seeWhatsAppMessages = true;
        this.seeSms = false;
      } else if (
        this.messageType.includes("Mensaje de texto") &&
        !this.messageType.includes("Notificación push")
      ) {
        if (this.messageType.includes("Notificación push")) {
          this.seeNotificationpush = true;
        }
        this.seeWhatsAppMessages = false;
        this.seeSms = true;
      } else if (this.messageType.includes("Notificación push")) {
        if (this.messageType.includes("Mensaje de texto")) {
          this.seeSms = false;
        }
        this.seeWhatsAppMessages = false;
        this.seeSms = false;
        this.seePush = true;
      }
    },
  },
  computed: {
    nombrePaciente() {
      if (this.infoPatient) {
        return `${this.infoPatient[0].valor} ${this.infoPatient[1].valor}`;
      }
      return null;
    },
  },
  props: {
    infoPatient: {
      type: Array,
      default: [],
    },
  },
  components: {
    WhatsAppMessage,
    TextMessage,
    PushMessage,
  },
};
</script>

<style lang="scss" scoped src="./MensajesUnificado.scss">
</style>


// WEBPACK FOOTER //
// src/components/Mensajes/MensajesUnificado/MensajesUnificado.vue